import { ChainId, JSBI, Percent, Token, WETH } from '@padiswap/sdk'

export const ROUTER_ADDRESS = '0x1C2DdB78F1fBDE389D15acd275ce6b51EAFbBA14'

// a list of tokens by chain
type ChainTokenList = {
  readonly [chainId in ChainId]: Token[]
}

export const WSYS = new Token(ChainId.MAINNET, '0xd3e822f3ef011Ca5f17D82C956D952D8d7C3A1BB', 18, 'WSYS', 'Wrapped SYS')
export const BNB = new Token(ChainId.MAINNET, '0xf27Ee99622C3C9b264583dACB2cCE056e194494f', 18, 'BNB', 'Binance')
export const BUSD = new Token(ChainId.MAINNET, '0x375488F097176507e39B9653b88FDc52cDE736Bf', 18, 'BUSD', 'Binance-Peg BUSD Token')
export const USDC = new Token(ChainId.MAINNET, '0x2bF9b864cdc97b08B6D79ad4663e71B8aB65c45c', 6, 'USDC', 'USD Coin')
export const USDT = new Token(ChainId.MAINNET, '0x922D641a426DcFFaeF11680e5358F34d97d112E1', 6, 'USDT', 'Tether USD')
export const WBTC = new Token(ChainId.MAINNET,  '0xc9BAA8cfdDe8E328787E29b4B078abf2DaDc2055', 8, 'WBTC', 'Wrapped BTC')
export const ETH = new Token(ChainId.MAINNET, '0x7C598c96D02398d89FbCb9d41Eab3DF0C16F227D',  18, 'ETH', 'Ethereum')

const WETH_ONLY: ChainTokenList = {
  [ChainId.MAINNET]: [WETH[ChainId.MAINNET]],
  [ChainId.TESTNET]: [WETH[ChainId.TESTNET]],
}

// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  ...WETH_ONLY,
  [ChainId.MAINNET]: [...WETH_ONLY[ChainId.MAINNET], BUSD, USDC, USDT, WBTC, ETH],
}

/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 */
export const CUSTOM_BASES: { [chainId in ChainId]?: { [tokenAddress: string]: Token[] } } = {
  [ChainId.MAINNET]: {},
}

// used for display in the default list when adding liquidity
export const SUGGESTED_BASES: ChainTokenList = {
  ...WETH_ONLY,
  [ChainId.MAINNET]: [...WETH_ONLY[ChainId.MAINNET], BUSD, USDT],
}

// used to construct the list of all pairs we consider by default in the frontend
export const BASES_TO_TRACK_LIQUIDITY_FOR: ChainTokenList = {
  ...WETH_ONLY,
  [ChainId.MAINNET]: [...WETH_ONLY[ChainId.MAINNET], BUSD, USDC, USDT],
}

export const PINNED_PAIRS: { readonly [chainId in ChainId]?: [Token, Token][] } = {
  [ChainId.MAINNET]: [
    [WSYS, BUSD],
    [WSYS, USDT],
  ],
}

export const NetworkContextName = 'NETWORK'

// default allowed slippage, in bips
export const INITIAL_ALLOWED_SLIPPAGE = 80
// 20 minutes, denominated in seconds
export const DEFAULT_DEADLINE_FROM_NOW = 60 * 20

// one basis point
export const ONE_BIPS = new Percent(JSBI.BigInt(1), JSBI.BigInt(10000))
export const BIPS_BASE = JSBI.BigInt(10000)
// used for warning states
export const ALLOWED_PRICE_IMPACT_LOW: Percent = new Percent(JSBI.BigInt(100), BIPS_BASE) // 1%
export const ALLOWED_PRICE_IMPACT_MEDIUM: Percent = new Percent(JSBI.BigInt(300), BIPS_BASE) // 3%
export const ALLOWED_PRICE_IMPACT_HIGH: Percent = new Percent(JSBI.BigInt(500), BIPS_BASE) // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
export const PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN: Percent = new Percent(JSBI.BigInt(1000), BIPS_BASE) // 10%
// for non expert mode disable swaps above this
export const BLOCKED_PRICE_IMPACT_NON_EXPERT: Percent = new Percent(JSBI.BigInt(1500), BIPS_BASE) // 15%

// used to ensure the user doesn't send so much ETH so they end up with <.01
export const MIN_ETH: JSBI = JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(16)) // .01 ETH
